import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Animations, MenuLink, MenuLinkExternal, MenuLinkTitle, MenuListItem } from './menuItem.styles';
import { MenuSubLinks } from '../menuSubLinks';
import { Hoverable } from '../../../../components/hoverable';

export class MenuItem extends PureComponent {
  static propTypes = {
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.string,
    list: PropTypes.object,
    isFeatured: PropTypes.bool,
    useSecondaryColor: PropTypes.bool,
  };

  registerMenuLinkClick = () => {
    dataLayer.push({
      event: 'Click',
      elementType: 'Menu Link',
      element: this.props.url,
    });
  };

  render() {
    const { list, isFeatured, useSecondaryColor, url, title } = this.props;

    const Link = url && url.includes('http') ? MenuLinkExternal : MenuLink;
    const to = url && url.includes('http') ? { href: url } : { to: url };

    return (
      <Hoverable>
        <Animations />
        <MenuListItem isFeatured={isFeatured} useSecondaryColor={useSecondaryColor}>
          <Link onClick={this.registerMenuLinkClick} {...to} isFeatured={isFeatured}>
            <MenuLinkTitle dropdown={!!list}>{title}</MenuLinkTitle>
          </Link>
          {list && <MenuSubLinks list={list} />}
        </MenuListItem>
      </Hoverable>
    );
  }
}
